// Helpers for the Spektrix two-entry membership model.
//
// A paid Spektrix membership is delivered as two basket entries:
//   1. A membershipSubscriptions[] entry with price/total of 0.
//   2. A donations[] entry holding the actual paid amount, against a fund
//      named after the membership.
// The subscription's `relatedDonationId` equals the donation's `id`. That
// linkage — NOT the fund name or fund type — is the reliable signal.

const linkedDonationIdSet = (subscriptions = []) => {
  const ids = new Set()
  for (const sub of subscriptions) {
    if (sub?.relatedDonationId) ids.add(sub.relatedDonationId)
  }
  return ids
}

const findLinkedDonation = (subscription, donations = []) => {
  const id = subscription?.relatedDonationId
  if (!id) return undefined
  return donations.find(d => d?.id === id)
}

const membershipDisplayPrice = (subscription, linkedDonation) => {
  if (linkedDonation && typeof linkedDonation.amount === 'number') {
    return linkedDonation.amount
  }
  if (typeof subscription?.price === 'number') {
    return subscription.price
  }
  if (typeof subscription?.membership?.price === 'number') {
    return subscription.membership.price
  }
  return 0
}

export { linkedDonationIdSet, findLinkedDonation, membershipDisplayPrice }
